import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=25615bf3&scoped=true"
import script from "./wel.vue?vue&type=script&lang=js"
export * from "./wel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25615bf3",
  null
  
)

export default component.exports